import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles({
});

function Billing(props) {
    const classes = useStyles();

    return (
        <h1>Billing settings</h1>
    );
}

export default Billing